<template>
  <ym-loadmore class="audio-detail-program-list"
               v-model="loading"
               :finished="allLoad"
               @load="fetchProgram"
  >
    <div class="program-list-desc">
      <div class="program-count">
        <span>{{ updateStatus | updateStatusFilter }}{{ updatedCount }}期</span>
      </div>
      <div class="program-operate">
        <ym-button v-if="isMobileWeb"
                   class="program-download-btn"
                   type="text"
                   icon="download"
                   v-ym-report:GROWTH_AUDIO_DETAIL_DOWNLOAD_AUDIO_CLICK=""
                   @click="linkApp"
        />
        <ym-button class="program-order-btn"
                   type="text"
                   :icon="order"
                   :disabled="orderDisabled"
                   @click="changeProgramOrder"
        />
      </div>
    </div>
    <audio-program-down-load title="提示"
                             text="下载少年商学院App，即可离线畅听音频课程"
                             :audio-id="id"
                             :show.sync="isShowDownloadTips"
                             name="AudioDetail"
    />
    <program-list class="program-list-detail"
                  :list="list"
                  :audio-type="type"
                  :order="order"
                  :show-empty="showEmpty"
    />
  </ym-loadmore>
</template>

<script>
  import { Button, Loadmore } from '@ymba/ym-ui';
  import PlayerPlaylistStorageMixin from '@/mixins/player/playerPlaylistStorage';
  import ProgramList from '@/pages/AudioProgram/components/ProgramList';
  import { getProgramList } from '@/services/program';
  import { LIMIT } from '@/utils/constant';
  import AudioProgramDownLoad from '@/pages/AudioProgram/components/AudioProgramDownLoad';
  import { isMobileWeb } from '@/utils';

  export default {
    name: 'AudioDetailProgramList',
    mixins: [PlayerPlaylistStorageMixin],
    components: {
      'ym-button': Button,
      'ym-loadmore': Loadmore,
      ProgramList,
      AudioProgramDownLoad,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      updateStatus: {
        type: String,
        required: true,
      },
      updatedCount: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      orderDefault: {
        type: String,
        default: 'desc',
        required: true,
      },
      showEmpty: Boolean,
    },
    data() {
      return {
        list: [],
        allLoad: false,
        order: 'desc',
        nextOrder: 'asc',
        orderDisabled: false,
        start: 0,
        loading: false,
        isShowDownloadTips: false,
        isMobileWeb: isMobileWeb(),
      };
    },
    filters: {
      updateStatusFilter(status) {
        return status === 'finished' ? '共' : '已更新';
      },
    },
    watch: {
      orderDefault(val) {
        this.initData(val);
      },
    },
    methods: {
      changeOrder(val) {
        this.order = val;
        this.nextOrder = val === 'desc' ? 'asc' : 'desc';
      },
      async fetchProgram(isLoadMore = true) {
        if (this.allLoad) return;

        this.loading = true;
        try {
          const data = await getProgramList({
            id: this.id,
            limit: LIMIT,
            sort: this.order,
            start: this.start,
          }, isLoadMore);

          if (data.list.length === 0) {
            this.allLoad = isLoadMore;
            this.loading = false;
            return;
          }

          const prevList = isLoadMore ? this.list : [];
          this.list = [...prevList, ...data.list];
          this.start = data.start;

          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      },
      initData(order) {
        this.changeOrder(order);
        this.fetchProgram(false);
      },
      async changeProgramOrder() {
        this.orderDisabled = true;

        this.changeOrder(this.nextOrder);

        this.start = 0;
        this.allLoad = false;
        try {
          await this.fetchProgram(false);
          this.handleGlobalSwitchSort(this.order);
          this.orderDisabled = false;
        } catch (e) {
          this.orderDisabled = false;
        }
      },
      linkApp() {
        this.isShowDownloadTips = true;
      },
    },
    created() {
      this.initData(this.orderDefault);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .program-list-desc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: @size-base @size-medium 0;
    color: @color-text-lighter;
  }

  .program-order-btn {
    min-width: auto;
    background: none;
    box-shadow: none;
    padding: 0;
    height: auto;
    font-size: 50px;
    color: @color-text-light;
  }

  .program-download-btn {
    min-width: auto;
    margin-right: 30px;
    background: none;
    box-shadow: none;
    padding: 0;
    height: auto;
    font-size: 50px;
    color: @color-text-light;
  }

  .program-list-detail {
    padding: 0 @size-medium;
  }
</style>
